import { withStyles } from '@material-ui/core';
import CompletedStopStatus from './CompletedStopStatus';
import PendingStopStatus from './PendingStopStatus';
import { stopStatus } from '../../../Utils';
import DelayedStopName from './DelayedStopName';
import TrailerDropStop from './TrailerDropStop';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../../appConfigContext';

const styles = (theme) => ({
  stopName: {
    borderRadius: '4px',
    background: theme.chatBGColor,
    color: theme.TextColor,
    fontWeight: 500,
    padding: '4px 8px',
    fontSize: theme.textFontSize,
    width: '95%'
  },
  activeStop: {
    borderRadius: '4px',
    color: theme.white,
    background: theme.HeaderSelectedText,
    fontWeight: 500,
    padding: '4px 8px',
    fontSize: theme.textFontSize,
    width: '95%'
  },
  delayedStop: {
    borderRadius: '4px',
    color: theme.TextColor,
    fontWeight: 500,
    padding: '4px 8px',
    fontSize: theme.textFontSize,
    width: '95%',
    minHeight: '40px',
    alignItems: 'center',
    display: 'grid'
  },
  detailContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  stopStatus: {
    fontSize: '10px',
    fontWeight: 500,
    borderRadius: '99px',
    padding: '2px 8px',
    textTransform: 'uppercase'
  },
  stopStatusCompleted: {
    color: theme.completeStopText,
    border: `1px solid ${theme.completeStopText}`,
    background: theme.trailerBackgroundColor
  },
  stopStatusWithException: {
    color: theme.ErrorMessageColor,
    border: `1px solid ${theme.ErrorMessageColor}`,
    background: theme.statusWrapperHighlightedColor
  },
  stopStatusPending: {
    color: theme.ToggleIconColor,
    border: `1px solid ${theme.ToggleIconColor}`,
    background: theme.StatusWrapperColor
  }
});
const getStopStatusClass = ({ stopData, classes, hasReturnOrException }) => {
  if (stopData.isStopCompleted || stopData.isDropStop) {
    if (hasReturnOrException) {
      return classes.stopStatusWithException;
    } else {
      return classes.stopStatusCompleted;
    }
  } else {
    return classes.stopStatusPending;
  }
};

const StopName = ({
  classes,
  stopData,
  active,
  isDelayStop,
  route,
  configJSON,
  staticClientStatusLists
}) => {
  const { status, hasReturnOrException } = stopStatus(stopData);
  const statusClass = getStopStatusClass({ stopData, classes, hasReturnOrException });

  return isDelayStop ? (
    <DelayedStopName
      stopData={stopData}
      classes={classes}
      statusClass={statusClass}
      status={status}
    />
  ) : (
    <div className={active ? classes.activeStop : classes.stopName}>
      <div className={classes.detailContainer}>
        <div>{stopData.consigneeDetails?.displayCustomerName}</div>
        <div className={`${classes.stopStatus} ${statusClass}`}>{status} {configJSON.enableNoFreightCode && stopData.noFreightCode &&`(${stopData.noFreightCode})`}</div>
      </div>
      {stopData.isStopCompleted || stopData.isDropStop ? (
        <CompletedStopStatus
          stopData={stopData}
          staticClientStatusLists={staticClientStatusLists}
        />
      ) : (
        <PendingStopStatus stopData={stopData} />
      )}
      {stopData.isDropStop ? <TrailerDropStop stopData={stopData} route={route} active={active}/> : null}
    </div>
  );
};

export default compose(withStyles(styles), withAppConfig)(StopName);
